<template>
  <v-card elevation="5">
    <v-card-title class="pb-0"> 篩選條件</v-card-title>
    <v-form v-model="valid" ref="form">
      <v-container class="py-0">
        <v-row>
          <!-- 時間區間 -->
          <v-col cols="12" md="4">
            <v-card-subtitle>
              時間區間
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" size="18"
                  >mdi-help-circle-outline
                  </v-icon
                  >
                </template>
                <span
                >因資料運算需要兩天的時間，所以日期都會從前天開始選取
                </span>
              </v-tooltip>
              <v-radio-group v-model="radioValue">
                <v-radio
                    v-for="item in timeInterval"
                    :value="item.value"
                    :key="item.index"
                    :label="`${item.title}`"
                    @click="recentDate(item.value)"
                    name="radioGroup"
                    class="py-1"
                ></v-radio>
                <v-radio name="radioGroup" @click="recentDate(0)">
                  <template v-slot:label>
                    <v-menu
                        ref="dateMenu"
                        v-model="dateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        min-width="290px"
                        offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateRangeText"
                            @click="datepickerClick(), recentDate(0)"
                            :rules="datePickerRule"
                            v-bind="attrs"
                            v-on="on"
                            readonly
                            dense
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="calendar"
                          picker-date.sync
                          :max="getDateRange(`maxDate`)"
                          :min="getDateRange(`minDate`)"
                          no-title
                          range
                          scrollable
                          show-current="false"
                      >
                        <v-spacer></v-spacer>

                        <v-btn
                            text
                            color="primary"
                            @click="$refs.dateMenu.save(calendar)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker
                      >
                    </v-menu>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-subtitle>
          </v-col>

          <!-- 標籤、來源 -->
          <v-col cols="12" md="4">
            <v-card-subtitle>
              選擇標籤
              <v-autocomplete
                  v-model="tag"
                  :rules="[rules.lengthRule]"
                  :items="getAPITags"
                  item-text="name"
                  item-value="id"
              ></v-autocomplete>
            </v-card-subtitle>
            <v-card-subtitle>
              來源
              <v-select
                  v-model="source"
                  :rules="[rules.lengthRule]"
                  :items="getAPISources"
                  item-text="name"
                  item-value="source"
                  single
                  chips
              ></v-select>
            </v-card-subtitle>
          </v-col>

          <!-- 到訪者 -->
          <v-col cols="12" md="4">
            <v-card-subtitle justify="space-around">
              到訪者
              <v-row>
                <v-col cols="6">
                  <v-checkbox
                      v-model="visitors"
                      :label="`訪客`"
                      :rules="[rules.lengthRule]"
                      value="0"
                  ></v-checkbox>
                </v-col>

                <v-col cols="6">
                  <v-checkbox
                      v-model="visitors"
                      :label="`會員`"
                      :rules="[rules.lengthRule]"
                      value="1"
                      hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-card-subtitle>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-card-actions class="justify-space-around flex-wrap">
      <v-btn @click="search" :loading="loading">搜尋</v-btn>
    </v-card-actions>
    <v-card-actions class="justify-space-around flex-wrap">
      <v-btn elevation="2" @click="getFileInfo()">{{ chartInfoState ? "下載資料" : "取得資料" }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import swal from "sweetalert2";
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";
import highcharts from "highcharts";

export default {
  props: {
    chartInfoState: Boolean,
    chartInfo: Array,
  },
  name: "customanalysisFilter",
  created() {
    this.initState("customanalysis");
  },
  methods: {
    ...mapActions("customanalysis", ["setOriginData"]),
    ...mapActions("filter", [
      "initState",
      "searchData",
      "recentDate",
      "searchSingleSourceData",
      "customizedDate",
    ]),
    async search() {
      try {
        // 防止重複送出
        if (this.loading) return;
        // 表單驗證
        if (this.$refs.form.validate()) {
          this.loading = true;
          await this.searchSingleSourceData("customanalysis");
          // await this.searchData("customanalysis");
          this.loading = false;
        }
      } catch (err) {
        swal.fire({
          title: "Oops...",
          text: "網路連線異常，請確認網路連線後再嘗試",
          icon: "error",
          width: "20rem",
        });
        this.loading = false;
      }
    },
    datepickerClick() {
      return (this.radioValue = 4);
    },
    // 匯出pdf
    getFileInfo() {
      if (this.chartInfoState === true) {
        this.exportCharts(this.chartInfo, {
          type: 'application/pdf',
          filename: '客群分析'
        });
      }
      this.$emit("changechartInfoState", !this.chartInfoState);
    },
    exportCharts(chartInfo, options) {
      let svgInfoList = [];

      svgInfoList = this.getSvgInfoList(chartInfo);
      // Merge the options
      options = highcharts.merge(highcharts.getOptions().exporting, options);
      // Post to export server
      highcharts.post(options.url, {
        filename: options.filename || 'chart',
        type: options.type,
        width: options.width,
        svg: this.getSVG(svgInfoList)
      });

    },
    getSVG(charts) {
      let chartList = [], topHeight = 0;
      let titleInitX = 100, titleInitY = 40, titleInitPx = 12, lineSize = 55;
      let textRangeY = 90;
      let blockList = [];

      for (let i = 0; i < charts.length; i++) {
        let height = this.getChartHeight(charts[i]);
        for (let j = 0; j < charts[i].titles.length / lineSize; j++) {
          chartList.push(this.setMessage(titleInitX, titleInitY + topHeight + j * titleInitPx, titleInitPx, charts[i].titles.substring(j * lineSize, (j + 1) * lineSize)));
        }
        chartList.push(this.chartToBlock(charts[i], 100, topHeight + textRangeY));
        topHeight += height + textRangeY;
        if (i % 2 === 1 || i === charts.length - 1) {
          blockList.push(JSON.parse(JSON.stringify(chartList)));
          chartList = [];
          topHeight = 0;
        }
      }
      return this.mergeTwoChartBlock(blockList);
    },
    getSvgInfoList(chartInfoList) {
      let svgInfoList = [], svgInfo = {};
      chartInfoList.forEach(e => {
        if (e.id === "CustomerGroupTrend") {
          if (e.data.subtitle.text !== "") {
            let title = "以" + e.data.title.text + "進行分析，" + e.data.subtitle.text + "的" +
                e.data.series[0].name.toString() + e.data.series[0].data[e.data.series[0].data.length - 1].toString() + "，" +
                e.data.series[1].name.toString() + e.data.series[1].data[e.data.series[0].data.length - 1].toString() + "，" +
                e.data.series[2].name.toString() + e.data.series[2].data[e.data.series[0].data.length - 1].toString() + "，" +
                e.data.series[3].name.toString() + e.data.series[3].data[e.data.series[0].data.length - 1].toString() + "。";
            e.data.subtitle.text = "";
            svgInfo = {
              titles: title,
              chart: highcharts.chart(e.id, e.data)
            };

          } else {
            svgInfo = {
              titles: "以" + e.data.title.text + "進行分析，" + e.data.xAxis.categories[e.data.xAxis.categories.length - 1].toString() + "的" +
                  e.data.series[0].name.toString() + e.data.series[0].data[e.data.series[0].data.length - 1].toString() + "，" +
                  e.data.series[1].name.toString() + e.data.series[1].data[e.data.series[0].data.length - 1].toString() + "，" +
                  e.data.series[2].name.toString() + e.data.series[2].data[e.data.series[0].data.length - 1].toString() + "，" +
                  e.data.series[3].name.toString() + e.data.series[3].data[e.data.series[0].data.length - 1].toString() + "。",
              chart: highcharts.chart(e.id, e.data)
            };
          }
        }
        if (e.id === "CustomerGroupAnalysis") {
          svgInfo = {
            titles: "客群分析圖-" +
                e.data.series[0].data[0].name + "占" + e.data.series[0].data[0].value + "% " +
                e.data.series[0].data[1].name + "占" + e.data.series[0].data[1].value + "% " +
                e.data.series[0].data[2].name + "占" + e.data.series[0].data[2].value + "% " +
                e.data.series[0].data[3].name + "占" + e.data.series[0].data[3].value + "% "
            ,
            chart: highcharts.chart(e.id, e.data)
          };
        }
        if (e.id === "newVisitors") {
          svgInfo = {
            titles: "新訪客日興趣類別排行，最關注的前三個標籤依序為" + e.data.xAxis.categories[0] + "," +
                e.data.xAxis.categories[1] + "," + e.data.xAxis.categories[2] + "。",
            chart: highcharts.chart(e.id, e.data)
          };
        }
        if (e.id === "activeCustomers") {
          svgInfo = {
            titles: "活躍客群日興趣類別排行，最關注的前三個標籤依序為" + e.data.xAxis.categories[0] + "," +
                e.data.xAxis.categories[1] + "," + e.data.xAxis.categories[2] + "。",
            chart: highcharts.chart(e.id, e.data)
          };
        }
        if (e.id === "potentialCustomers") {
          svgInfo = {
            titles: "潛在客群日興趣類別排行，最關注的前三個標籤依序為" + e.data.xAxis.categories[0] + "," +
                e.data.xAxis.categories[1] + "," + e.data.xAxis.categories[2] + "。",
            chart: highcharts.chart(e.id, e.data)
          };
        }
        if (e.id === "returningVisitors") {
          svgInfo = {
            titles: "回流訪客日興趣類別排行，最關注的前三個標籤依序為" + e.data.xAxis.categories[0] + "," +
                e.data.xAxis.categories[1] + "," + e.data.xAxis.categories[2] + "。",
            chart: highcharts.chart(e.id, e.data)
          };
        }
        svgInfoList.push(svgInfo);
      })
      return svgInfoList;
    },
  },
  computed: {
    ...mapGetters("filter", [
      "getCustomizedDate",
      "getDateRange",
      "getAPISources",
      "getAPITags",
    ]),
    ...mapFields("filter", [
      "customanalysis.radioValue",
      "customanalysis.source",
      "customanalysis.tag",
      "customanalysis.visitors",
    ]),
    optionLoaded() {
      return this.getAPISources.length === 0;
    },
    calendar: {
      get() {

        return this.getCustomizedDate;
      },
      set(dates) {
        dates = dates.sort((a, b) => Date.parse(a) - Date.parse(b));
        this.customizedDate({date: dates});
      },
    },
    dateRangeText() {
      const dateArray = [...this.calendar];
      return dateArray.join(" ~ ").replace(/-/g, "/");
    },
    datePickerRule() {
      //選中自定義日期才需要驗證
      return this.radioValue == 4 && !this.dateMenu
          ? this.rules.datepickerRule
          : [];
    },
  },
  data: () => ({
    valid: false,
    loading: false,
    dateMenu: false,
    rules: {
      lengthRule: (v) => (v && v.length > 0) || "請至少選擇一項",
      multiSelectRule: (v) => (v && v.length < 3) || "來源最多選擇兩項",
      datepickerRule: [
        (v) => (v && v.length > 20) || "請選擇起始日與結束日",
        (v) =>
            (v && new Set(v.split(" ~ ")).size !== 1) || "起始日不得與結束日相同",
      ],

    },

    timeInterval: [
      {title: "最新 7 天", value: 7},
      {title: "最新 15 天", value: 15},
      {title: "最新 30 天", value: 30},
      {title: "最新 60 天", value: 60},
    ],
  }),
};
</script>

<style scoped>
::v-deep .v-list-item__mask {
  background: #FFFF77 !important;
}
</style>
